import { h, render } from "preact";

/**
 * Get the props from a host element's data attributes
 */
const collect_props_from_element = function (element: HTMLElement): {} {
    const props = Object();

    // check for child script text/props
    [].forEach.call(element.getElementsByTagName("script"), function (scrp) {
        let propsObj = {};
        if (scrp.hasAttribute("type")) {
            if (scrp.getAttribute("type") !== "text/props") {
                return;
            }
            try {
                propsObj = JSON.parse(scrp.innerHTML);
            } catch (e) {
                console.error("Cannot parse JSON", element);
            }
            Object.assign(props, propsObj);
        }
    });

    return props;
};

// TODO: Check Preact custom Web Components
// TODO: https://preactjs.com/guide/v10/web-components
// TODO: Check https://blog.bitsrc.io/web-components-without-a-framework-lets-build-a-modal-a450a4536340

/*
 * Run Preact render for not rendered widgets
 * Inspired by https://github.com/zouhir/preact-habitat
 */
const render_widgets = function (available_widgets) {
    const load_preact_components = function () {
        const widgets = document.querySelectorAll("[data-widget]");

        [].forEach.call(widgets, function (widget_elm) {
            // get Preact component
            const widget_name = widget_elm.getAttribute("data-widget");
            const widget_append = widget_elm.getAttribute("data-widget-append");
            const widget = available_widgets[widget_name];

            if (widget === undefined) {
                return;
            }

            // get config
            const props = collect_props_from_element(widget_elm);

            // render to right element
            let target_elm;
            if (widget_append) {
                // have to append new element inside widget element
                target_elm = document.createElement("div");

                widget_elm.appendChild(target_elm);
                widget_elm.removeAttribute("data-widget");
                widget_elm.removeAttribute("data-widget-append");
            } else {
                target_elm = widget_elm;
            }

            render(h(widget, { ...props, _root_node: target_elm }), target_elm.parentNode, target_elm);
        });
    };

    // initial component loading
    document.addEventListener("DOMContentLoaded", load_preact_components);
    if (document.readyState != "loading") {
        // in case event listener was missed, call load component directly
        load_preact_components();
    }

    return load_preact_components;
};

export default render_widgets;
